<template>
    <div class="row my-2 py-1 border border-success">
        <div class="col-sm-4">
            <BaseInput
				name="Stay Place"
				label="Stay Place"
				type="text"
				v-model="data.stayPlace"
				:required="true"
				class="form-control form-control-lg dashInput"
				rules="required|min:3"
			/>
        </div>
        <div class="col-sm-2">
            <BaseInput
				name="Night Stay Count"
				label="Night Stay Count"
				type="number"
				v-model="data.stay"
				:min="1"
				:required="true"
				class="form-control form-control-lg dashInput"
				rules="required"
			/>
        </div>
        <div class="col-sm-6 position-relative">
            <BaseMultiSelect
                @update:value="setHotels"
                :options="hotels"
                :defaultData="data.hotels"
                mode="tags"
                rules="required"
                name="Hotels"
            />
        </div>
    </div>
</template>
<script>
import { reactive, watch } from "vue";
import BaseMultiSelect from "./BaseMultiSelect.vue";
import BaseInput from "./BaseInput.vue";

export default {
    name: "sightHotel",
    components: {
        BaseMultiSelect,
        BaseInput
    },
    props: {
        defaultData: { type: [Object, Boolean, String], default: false },
        hotels: { type: Array, default: [] },
        sights: { type: Array, default: [] },
        stay: { type: Number, default: 0 },
        maxStay: { type: Number, default: 0 }
    },
    emits: ["add-data"],

    setup: (props, { emit }) => {

        const data = reactive({
            id: props.id,
            stayPlace: "",
            hotels: [],
            stay: 0,
        })

        if (Object.keys(props.defaultData).length) {
            Object.keys(data).map(key => data[key] = props.defaultData[key] || data[key]);
        }

        watch(data, (newVAlue, preValue) => {
            if (data.stayPlace && data.hotels.length && data.stay) {
                emit("add-data", data);
            }
            return true;
        })

        const setHotels = (hotels) => {
            data.hotels = [...hotels];
        }

        return {
            data,
            setHotels,
        }
    }
}
</script>